import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "dialog-footer" }

import type { ElForm } from "element-plus";
import { getlistQuestions } from "@/api/backstage";
import { reactive, ref, onMounted, nextTick, watch} from "vue";

type FormInstance = InstanceType<typeof ElForm>;


export default /*@__PURE__*/_defineComponent({
  __name: 'select',
  props: {
  row: {
    type: Object,
    default: () => {
      return null;
    },
  },
},
  emits: ["close","close1"],
  setup(__props, { emit: __emit }) {

const multipleTableRef: any = ref();

const form = ref<FormInstance>();
const visible = ref(true);
const multipleSelection: any = ref([]);

const props = __props;

if (props.row) {
  multipleSelection.value = props.row;
  multipleTableRef.value?.clearSelection();
  nextTick(() => {
    if (multipleSelection.value) {
      multipleSelection.value.forEach((row: any) => {
        multipleTableRef.value!.toggleRowSelection(row, true); // 回显打勾
      });
    }
  });
}

const emit = __emit;

const datas: any = reactive({
  preview: "",
  konwles: "",
  tableData: [],
  total: 0,
  subject: [],
  type: {
    QUESTION_ONE:{
      enumName: '单选',
      enumKey: 'QUESTION_ONE'
    },
    QUESTION_MORE:{
      enumName: '多选',
      enumKey: 'QUESTION_MORE'
    },
    QUESTION_SHORT:{
      enumName: '简答',
      enumKey: 'QUESTION_SHORT'
    },
      QUESTION_NUM: {
      enumName: "打分",
      enumKey: "QUESTION_NUM",
    },
  },
  form: {
    pageNum: 1,
    pageSize: 10,
    title: "",
    type: "",
  },
});

const getList = () => {
  getlistQuestions(datas.form).then((res: any) => {
    datas.tableData = res?.data.list ?? [];
    datas.total = res?.data.total ?? 0;
  });
};
// 类型筛选
const typeChange = (val: any) => {
 datas.form.type=val;
 getList();
};



const handleSizeChange = (val: number) => {
  datas.form.pageSize = val;
  getList();
};
const handleCurrentChange = (val: number) => {
  datas.form.pageNum = val;
  getList();
};
const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();
  getList();
};
const handleSelectionChange = (val: any) => {
  multipleSelection.value = val;
};

const close = () => {
  emit("close", multipleSelection.value);
};

const close1 = () => {
  emit("close1", multipleSelection.value);
};

onMounted(() => {
  getList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
    title: "选择题目",
    width: "60%",
    style: {"z-index":"4"},
    onClose: close1
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, { onClick: close1 }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: close
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode("确定", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        inline: true,
        ref_key: "form",
        ref: form,
        model: datas.form,
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
        class: "demo-form-inline"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "标题",
            prop: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: datas.form.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((datas.form.title) = $event)),
                onKeyup: _withKeys(getList, ["enter","native"]),
                placeholder: "关键字"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "类型",
            prop: "type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: datas.form.type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((datas.form.type) = $event)),
                placeholder: "请选择",
                onChange: typeChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.type, (v, k) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: v.enumName,
                      value: k,
                      key: k
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: getList
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("搜索", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (resetForm(form.value)))
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("重置", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createVNode(_component_el_table, {
        ref_key: "multipleTableRef",
        ref: multipleTableRef,
        data: datas.tableData,
        style: {"width":"100%"},
        "row-key": "id",
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            width: "55",
            "reserve-selection": true
          }),
          _createVNode(_component_el_table_column, {
            prop: "title",
            label: "题干"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", {
                innerHTML: row.title
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "type",
            label: "类型"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(datas.type[row.type]?.enumName), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_el_pagination, {
        currentPage: datas.form.pageNum,
        "page-size": datas.form.pageSize,
        "page-sizes": [5, 10, 20, 50],
        background: "",
        layout: "total, sizes, prev, pager, next, jumper",
        total: Number(datas.total),
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["currentPage", "page-size", "total"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})